module.exports = __webpack_public_path__ + "img/f3aa64fa-cdc6-46de-ae37-c8890b9e527d.770a1b1a.svg";